module.exports = __webpack_public_path__ + "img/kefu.f7c9145f.png";